import { IPendingRequestAction } from "../actions/types/pendingRequestTypes";

export type PendingRequestState = {
  onAccept: boolean;
  onReject: boolean;
  selectPendingRequest: any;
  listPendingRequest: Array<any>;
  listPendingRequestFilter: Array<any>;
  error: any;
  loading: boolean;
};

const initialState: PendingRequestState = {
  onAccept: false,
  onReject: false,
  listPendingRequest: [],
  listPendingRequestFilter: [],
  selectPendingRequest: null,
  loading: false,
  error: null,
};

export const pendingRequestReducer = (
  state: PendingRequestState = initialState,
  action: IPendingRequestAction<any>
): PendingRequestState => {
  switch (action.type) {
    case "ON_ACCEPT_PENDING_REQUEST":
      return {
        ...state,
        onAccept: action.payload,
      };
    case "ON_REJECT_PENDING_REQUEST":
      return {
        ...state,
        onReject: action.payload,
      };
    case "SELECT_PENDING_REQUEST":
      return {
        ...state,
        selectPendingRequest: action.payload,
      };
    case "PENDING_REQUEST_FAILURE":
      return {
        ...state,
        error: action.payload,
      };
    case "SET_PENDING_REQUESTS":
      return {
        ...state,
        listPendingRequest: action.payload,
      };
    case "SET_PENDING_REQUESTS_FILTER":
      return {
        ...state,
        listPendingRequestFilter: action.payload,
      };
    case "DELETE_PENDING_REQUEST":
      const listPendingRequestFilter = state.listPendingRequest.filter(
        (pendingRequest) => pendingRequest.id !== action.payload
      );
      return {
        ...state,
        listPendingRequest: listPendingRequestFilter,
      };
    case "START_LOADING":
      return {
        ...state,
        loading: true,
      };
    case "STOP_LOADING":
      return {
        ...state,
        loading: false,
      };
    case "RESET_PENDING_REQUEST":
      return initialState;
    default:
      return state;
  }
};
